import * as React from "react";
const SvgFiRrCoinUpArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-coin-up-arrow_svg__a)">
      <path
        fill="#062147"
        d="M7 10c-3.859 0-7 3.14-7 7s3.141 7 7 7 7-3.14 7-7-3.141-7-7-7m0 12c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5m2.742-6.499a.878.878 0 0 1-.622 1.498H7.999v2a1 1 0 1 1-2 0v-2H4.878a.879.879 0 0 1-.622-1.499l1.5-1.5a1.76 1.76 0 0 1 2.485 0l1.5 1.5zM16.5 0C12.225 0 9 1.72 9 4v3.5a1 1 0 1 0 2 0v-.726C12.349 7.537 14.283 8 16.5 8s4.151-.463 5.5-1.226V8c0 .796-2.193 2-5.5 2-.634 0-1.257-.045-1.853-.134a1.005 1.005 0 0 0-1.137.842 1 1 0 0 0 .842 1.137c.693.103 1.416.155 2.147.155 2.217 0 4.151-.463 5.5-1.226V12c0 .796-2.193 2-5.5 2a1 1 0 1 0 0 2c2.217 0 4.151-.463 5.5-1.226V16c0 .796-2.193 2-5.5 2a1 1 0 1 0 0 2c2.217 0 4.151-.463 5.5-1.226V20c0 .796-2.193 2-5.5 2-.47 0-.938-.025-1.393-.074a1 1 0 1 0-.215 1.988c.524.057 1.065.086 1.607.086 4.275 0 7.5-1.72 7.5-4V4c0-2.28-3.225-4-7.5-4zm0 6C13.193 6 11 4.796 11 4s2.193-2 5.5-2S22 3.204 22 4s-2.193 2-5.5 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-coin-up-arrow_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCoinUpArrow;
